const padDatePart = (value: number) => String(value).padStart(2, '0');

export const toLocalDateInputValue = (value = new Date()) =>
  `${value.getFullYear()}-${padDatePart(value.getMonth() + 1)}-${padDatePart(value.getDate())}`;

export const shiftLocalDateInputValue = (value: string, days: number) => {
  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + days);
  return toLocalDateInputValue(date);
};
